import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('setup-guide-ui');